import { render } from "./ArrayField.vue?vue&type=template&id=0446c53a&scoped=true"
import script from "./ArrayField.vue?vue&type=script&lang=js"
export * from "./ArrayField.vue?vue&type=script&lang=js"

import "./ArrayField.vue?vue&type=style&index=0&id=0446c53a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0446c53a"]])

export default __exports__